import { gql } from '@apollo/client';
import { rateUnitFragment } from 'helper/fragment';

export const ACTIVE_BIDS = gql`
  ${rateUnitFragment}
  query bids(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    bids(
      filter: $filter

      pageNo: $pageNo

      pageSize: $pageSize

      sortCol: $sortCol

      sortDirection: $sortDirection
    ) {
      bids {
        id

        price

        bidType

        quantity

        quantityUnit

        bidder {
          tradeName

          firstName

          middleName

          lastName

          phone

          status

          addresses {
            street

            city {
              cityName
            }

            state {
              stateName
            }
          }
        }
        total
        offer {
          id
          offerType
          activeBids
          inactiveBids
        }

        demand {
          id
          demandType
          activeBids
          inactiveBids
        }

        grade {
          name
        }

        rateUnit {
          ...rateUnitInfo
        }

        status
      }

      totalCount

      totalPages
    }
  }
`;

export const QUANTITY_TRADED = gql`
  query tradedQuantitySummary(
    $fromDate: String
    $toDate: String
    $groupOn: String
  ) {
    tradedQuantitySummary(
      fromDate: $fromDate
      toDate: $toDate
      groupOn: $groupOn
    ) {
      group

      quantity
    }
  }
`;

export const SALES_SUMMARY = gql`
  query salesSummary($fromDate: String, $toDate: String, $groupOn: String) {
    salesSummary(fromDate: $fromDate, toDate: $toDate, groupOn: $groupOn) {
      group
      amount
    }
  }
`;

export const LISTINGS = gql`
  query listingsSummary($spanDays: Int) {
    listingsSummary(spanDays: $spanDays) {
      currentOffers
      offersTrend
      currentDemands
      demandsTrend
      totalOffers
      totalDemands
    }
  }
`;

export const TRANSPORTATION_DATA = gql`
  query transportationCountData(
    $fromDate: String
    $toDate: String
    $groupOn: String
  ) {
    transportationCountData(
      fromDate: $fromDate
      toDate: $toDate
      groupOn: $groupOn
    )
  }
`;

export const INVOICE_COUNT_DATA = gql`
  query invoiceCountData($fromDate: String, $toDate: String, $groupOn: String) {
    invoiceCountData(fromDate: $fromDate, toDate: $toDate, groupOn: $groupOn)
  }
`;

export const ORDER_DATA = gql`
  query orderCountData($fromDate: String, $toDate: String, $groupOn: String) {
    orderCountData(fromDate: $fromDate, toDate: $toDate, groupOn: $groupOn)
  }
`;

export const VENDOR_DATA = gql`
  query vendorsCountData($fromDate: String, $toDate: String, $groupOn: String) {
    vendorsCountData(fromDate: $fromDate, toDate: $toDate, groupOn: $groupOn)
  }
`;

export const LISTING_DATA = gql`
  query listingCountData($fromDate: String, $toDate: String, $groupOn: String) {
    listingCountData(fromDate: $fromDate, toDate: $toDate, groupOn: $groupOn)
  }
`;

export const BIDS_DATA = gql`
  query bidsCountData($fromDate: String, $toDate: String, $groupOn: String) {
    bidsCountData(fromDate: $fromDate, toDate: $toDate, groupOn: $groupOn)
  }
`;

export const TRANSPORTATION_SUMMARY = gql`
  query transportationsSummary($fromDate: String, $toDate: String) {
    transportationsSummary(fromDate: $fromDate, toDate: $toDate) {
      loading
      delivered
      dispatched
    }
  }
`;

export const TRANSPORTATION_SUMMARY_SUBSCRIPTION = gql`
  subscription transportationsSummary($fromDate: String, $toDate: String) {
    transportationsSummary(fromDate: $fromDate, toDate: $toDate) {
      loading
      delivered
      dispatched
    }
  }
`;

export const INVOICE_SUMMARY = gql`
  query invoicesSummary($fromDate: String, $toDate: String) {
    invoicesSummary(fromDate: $fromDate, toDate: $toDate) {
      paidFully
      paidPartially
      invoiceUnpaid
    }
  }
`;

export const INVOICE_SUMMARY_SUBSCRIPTION = gql`
  subscription invoicesSummary($fromDate: String, $toDate: String) {
    invoicesSummary(fromDate: $fromDate, toDate: $toDate) {
      paidFully
      paidPartially
      invoiceUnpaid
    }
  }
`;

export const LISTING_SUMMARY = gql`
  query listingsSummary($fromDate: String, $toDate: String) {
    listingsSummary(fromDate: $fromDate, toDate: $toDate) {
      offers
      demands
    }
  }
`;

export const OFFER_LISTING_SUMMARY_SUBSCRIPTION = gql`
  subscription listingsSummaryOffer($fromDate: String, $toDate: String) {
    listingsSummaryOffer(fromDate: $fromDate, toDate: $toDate) {
      offers
      demands
    }
  }
`;

export const DEMAND_LISTING_SUMMARY_SUBSCRIPTION = gql`
  subscription listingsSummaryDemand($fromDate: String, $toDate: String) {
    listingsSummaryDemand(fromDate: $fromDate, toDate: $toDate) {
      offers
      demands
    }
  }
`;
export const BIDS_SUMMARY = gql`
  query bidsSummary($fromDate: String, $toDate: String) {
    bidsSummary(fromDate: $fromDate, toDate: $toDate) {
      offers
      demands
    }
  }
`;

export const BIDS_SUMMARY_SUBSCRIPTION = gql`
  subscription bidsSummary($fromDate: String, $toDate: String) {
    bidsSummary(fromDate: $fromDate, toDate: $toDate) {
      offers
      demands
    }
  }
`;

export const VENDOR_SUMMARY = gql`
  query vendorsSummary($fromDate: String, $toDate: String) {
    vendorsSummary(fromDate: $fromDate, toDate: $toDate) {
      newVendors
      totalVendors
    }
  }
`;

export const VENDOR_SUMMARY_SUBSCRIPTION = gql`
  subscription vendorsSummary($fromDate: String, $toDate: String) {
    vendorsSummary(fromDate: $fromDate, toDate: $toDate) {
      newVendors
      totalVendors
    }
  }
`;

export const ORDER_SUMMARY = gql`
  query ordersSummary($fromDate: String, $toDate: String) {
    ordersSummary(fromDate: $fromDate, toDate: $toDate) {
      paid
      pending
    }
  }
`;

export const ORDER_SUMMARY_SUBSCRIPTION = gql`
  subscription ordersSummary($fromDate: String, $toDate: String) {
    ordersSummary(fromDate: $fromDate, toDate: $toDate) {
      paid
      pending
    }
  }
`;

export const ORDERS_BY_LOCATION = gql`
  query OrdersByLocation($fromDate: String, $toDate: String) {
    ordersByLocation(fromDate: $fromDate, toDate: $toDate) {
      latitude
      longitude
    }
  }
`;

export const OrderCountsByStatus = gql`
  query OrderCountsByStatus {
    orderCountsByStatus {
      status
      count
      percent
    }
  }
`;

export const OrderCountsByStatusSubscription = gql`
  subscription OrderCountsByStatus {
    orderCountsByStatus {
      status
      count
      percent
    }
  }
`;

export const TOTAL_LISTING = gql`
  query totalListing {
    totalListing {
      totalBids
      totalVendors
      totalInvoices
      totalListing
    }
  }
`;

// export const TOTAL_LISTING_SUBSCRIPTION = gql`
//   subscription totalListing {
//     totalListing {
//       totalBids
//       totalVendors
//       totalInvoices
//       totalListing
//     }
//   }
// `;

export const LATEST_ACTIVE_BIDS = gql`
  ${rateUnitFragment}

  query groupedBids(
    $flag: String
    $bidType: BidOrderType
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
    $createdAt: String
  ) {
    groupedBids(
      flag: $flag
      bidType: $bidType
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
      createdAt: $createdAt
    ) {
      totalPages
      totalCount
      groupedBids {
        latestBid {
          id
          bidType
          offer {
            id
            totalQty
            minimumQty
            quantityUnit
            rate
            grade {
              id
              name
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidExpireTime
          demand {
            id
            totalQty
            minimumQty
            quantityUnit
            rate
            grades {
              id
              name
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidder {
            firstName
            lastName
            addresses {
              id
              houseNumber
            }
          }
          grade {
            id
            name
          }
          price
          rateUnit {
            ...rateUnitInfo
          }
          bidderRole
          quantity
          quantityUnit
          status
          updatedAt
        }
      }
    }
  }
`;

export const LATEST_ACTIVE_BIDS_SUBSCRIPTION = gql`
  ${rateUnitFragment}

  subscription groupedBids(
    $flag: String
    $bidType: BidOrderType
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    groupedBids(
      flag: $flag
      bidType: $bidType
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      totalPages
      totalCount
      action
      groupedBid {
        latestBid {
          id
          bidType
          offer {
            id
            totalQty
            minimumQty
            quantityUnit
            rate
            grade {
              id
              name
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidExpireTime
          demand {
            id
            totalQty
            minimumQty
            quantityUnit
            rate
            grades {
              id
              name
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidder {
            firstName
            lastName
            addresses {
              id
              houseNumber
            }
          }
          grade {
            id
            name
          }
          price
          rateUnit {
            ...rateUnitInfo
          }
          bidderRole
          quantity
          quantityUnit
          status
          updatedAt
        }
      }
    }
  }
`;

// export const USERS = gql`
//   query usersSummary($spanDays: Int) {
//     usersSummary(spanDays: $spanDays) {
//       count
//       status
//       trend
//     }
//   }
// `;

// export const ORDERS = gql`
//   query ordersSummary($spanDays: Int) {
//     ordersSummary(spanDays: $spanDays) {
//       count
//       status
//       trend
//     }
//   }
// `;
